import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { RuntimeEnvironments } from '@environments/runtimeEnviroments.enum';
import { EnvironmentService } from '@service/environment.service';
import { GraphsService } from '@service/graphs.service';
import { ResponsiveService } from '@service/responsive.service';
import { SimulatorService } from '@service/simulator.service';
import { MimicGroupsService } from '@service/mimic-groups.service';
import { Graph } from 'ops/common/models/graphs';
import { Subscription } from 'rxjs';
import { VesselService } from '@service/vessel.service';
import { Mimic } from 'ops/common/models/mimic';
import { MimicService } from '@service/mimic.service';

@Component({
    selector: 'app-ops-sidebar',
    templateUrl: './ops-sidebar.component.html',
    styleUrls: ['./ops-sidebar.component.scss'],
    standalone: false,
})
export class OpsSidebarComponent implements OnInit, AfterViewInit {
    projectLoadSub: Subscription;
    toggleIconVisibilitySub: Subscription;
    isMimicDropdownOpen = false;
    showSubMimics: Boolean = false;
    mimicGroups: any = [];
    mimics: Mimic[];
    graphs: Graph[] = [];
    selectedGroup;
    mimicsListArray: any[] = [];
    extendSidebar: boolean = false;
    runningOnCloud: boolean = false;
    env: RuntimeEnvironments;

    @Input() sidebarHidden: boolean;
    @Input() sidebarExtends: boolean;
    @Output() onSidebarExtends = new EventEmitter();

    constructor(
        private changeDetector: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private mimicGroupsService: MimicGroupsService,
        public responsive: ResponsiveService,
        private environmentService: EnvironmentService,
        private simulatorService: SimulatorService,
        private graphsService: GraphsService,
        private vesselService: VesselService,
        private mimicService: MimicService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.env = this.environmentService.getEnvironment();
        if (this.env === RuntimeEnvironments.CLOUD) {
            this.runningOnCloud = true;
        }
    }

    async ngAfterViewInit() {
        try {
            this.mimicGroups = await this.mimicGroupsService.getAll();
            this.mimics = await this.mimicService.getAll();
            this.graphs = await this.graphsService.getAll();
            this.updateGroupsList();
        } catch (err) {
            console.error(err);
        }
        this.projectLoadSub = this.vesselService.onVesselUpdated.subscribe(async () => {
            this.mimics = await this.mimicService.getAll();
            this.mimicGroups = await this.mimicGroupsService.getAll();
            this.graphs = await this.graphsService.getAll();
            this.updateGroupsList();
            this.changeDetector.detectChanges();
        });
    }

    asView(val): any {
        return val;
    }

    stopPropagation(event: Event): void {
        event.stopPropagation();
    }

    toggleDropdown(type) {
        this.isMimicDropdownOpen = !this.isMimicDropdownOpen;
        if (type == 'mimic') {
            this.selectedGroup = null;
        }

        if (this.isMimicDropdownOpen && this.selectedGroup) {
            this.showSubMimics = true;
        } else {
            this.showSubMimics = false;
        }
    }

    onExtendSidebar() {
        this.onSidebarExtends.emit();
    }

    isActiveLink(link: string) {
        return this.router.url.includes(link);
    }

    isgroupActive(groupName: string) {
        return this.selectedGroup && this.selectedGroup.name === groupName;
    }

    groupSelected(group) {
        this.showSubMimics = true;
        this.selectedGroup = group;
    }

    updateGroupsList() {
        this.mimicsListArray = [];
        this.mimicGroups.forEach((mimicGroup) => {
            const listItem = {
                type: 'mimicGroup',
                name: mimicGroup.groupName,
                id: mimicGroup.id,
                mimics: [],
            };
            this.mimicsListArray.push(listItem);
        });
        if (this.mimics) {
            this.updateList();
        }
    }

    updateList() {
        this.mimics.forEach((mimic) => {
            let found = false;
            const listItem = {
                type: 'mimic',
                name: mimic.name,
                id: mimic.id,
            };
            this.mimicsListArray.forEach((group) => {
                if (group.type === 'mimicGroup' && group.id === mimic.mimicGroupId) {
                    found = true;
                    group.views.push(listItem);
                }
            });
            if (!found) {
                this.mimicsListArray.push(listItem);
            }
        });
    }

    onNavigateView(viewUrlObj: { url: string; queryParams?: any }) {
        const mimicId = viewUrlObj.queryParams.id;
        if (!mimicId) return;
        this.sidebarExtends = false;
        this.router.navigate(['ops', 'mimics', mimicId]);
    }

    onNavigateTo(url: string) {
        if (this.sidebarExtends) {
            this.onSidebarExtends.emit();
        }
        this.isMimicDropdownOpen = false;
        const segments = url.split('/').filter((segment) => segment);
        this.router.navigate(segments);
    }

    async onOpenSimulator() {
        if (environment.apiPort) {
            window.location.href = 'http://localhost:4500/';
        } else {
            const { simulatorUrl } = await this.simulatorService.getUrl();
            window.location.href = simulatorUrl;
        }
    }
}
